export type ContactOriginInput = {
  source: string;
  company?: string | null;
  metadata?: unknown;
  subjectName?: string | null;
  listingTitle?: string | null;
  campaignName?: string | null;
};

export type ContactOrigin = {
  label: string;
  sentence: string;
};

function text(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

function metadataRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

function subject(input: ContactOriginInput): string | null {
  const meta = metadataRecord(input.metadata);
  return (
    text(input.subjectName) ??
    text(meta.businessName) ??
    text(input.company)
  );
}

export function contactOrigin(input: ContactOriginInput): ContactOrigin {
  const name = subject(input);
  switch (input.source) {
    case "RESEARCH":
      return {
        label: "Found by Venturu AI",
        sentence: name
          ? `Venturu AI found this owner while researching ${name}.`
          : "Venturu AI found this person while researching a business.",
      };
    case "INQUIRY":
      return {
        label: "Listing inquiry",
        sentence: input.listingTitle
          ? `Sent an inquiry about ${input.listingTitle}.`
          : "Sent an inquiry about a listing.",
      };
    case "LEAD_GENERATION":
      return {
        label: "Lead Generation ad",
        sentence: input.campaignName
          ? `Filled out your ${input.campaignName} ad form.`
          : "Filled out one of your ad forms.",
      };
    case "IMPORT":
      return {
        label: "Imported",
        sentence: "Added from a file you imported.",
      };
    case "REFERRAL":
      return {
        label: "Referral",
        sentence: "Came in as a referral.",
      };
    case "CAMPAIGN":
      return {
        label: "Campaign",
        sentence: input.campaignName
          ? `Came in through ${input.campaignName}.`
          : "Came in through a campaign.",
      };
    case "INTAKE":
      return {
        label: "Intake form",
        sentence: "Filled out an intake form.",
      };
    case "LEAD_SOURCING":
      return {
        label: "Lead sourcing",
        sentence: name
          ? `Saved from Lead Sourcing while looking at ${name}.`
          : "Saved from Lead Sourcing.",
      };
    case "MANUAL":
      return {
        label: "Added by you",
        sentence: "Added by someone on your team.",
      };
    default:
      return {
        label: "Contact",
        sentence: "Added to this workspace.",
      };
  }
}
